









import { defineComponent } from '@vue/composition-api'
import Modal from '@/components/Modal/Modal.vue'
import { ModalComposition } from '@/composition/UseModalComposition'
import { StorageComposition } from '@/composition/UseStorageComposition'

// ================================
// Props
// ================================
export type SectionModalProps = {
  modal: ModalComposition;
  storage: StorageComposition;
}

// ================================
// Component
// ================================
export default defineComponent({
  name: 'SectionModal',
  components: { Modal },
  props: ['modal', 'storage'],
  setup (props: SectionModalProps) {
    return {
      props
    }
  }
})
